<template>
	<div id="yonghuxieyi" >
		<div class="download_header">
			<img class="download_header_img" src="../assets/img/download/downlogo.png" />
		</div>
		<!--体开始-->
		<div id="y_main">
			<!--富文本内容-->
			<div id="agree_rdt" v-html="agreements_rdt">
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				agreements_rdt:``,//用户协议富文本
				contentShow:0,			//是否显示内容
			}
		},
//		beforeRouteLeave(to, from, next) {
//			if (to.path == "/register") {
//					to.meta.keepAlive = true;
//	 			}else{
//	 				to.meta.keepAlive = false;
//	 			}
//				next();
//		},
		mounted(){
			//请求数据
			let that=this;
			this.$http.get(
//				'http://39.104.14.210/dataGalaxy/index.php?m=Api&c=content&a=user_agreement',
				that.apiUrl+'index.php?m=Api&c=content&a=user_agreement',
			).then(response => {

						//进行数据验证
						if(response.body.status != 1){
							
							//显示错误页面
//							this.$router.push('/404')
//							this.$message({
//								message: '请求错误',
//								type: 'warning',
//								dangerouslyUseHTMLString:true,
//								customClass: 'message-warning',
//							});
							return;
						}
						
						if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
							
							//显示空数据页面
							this.$message({
								message: '暂无数据',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
							return;
						}
						this.contentShow = 1;
						this.agreements_rdt = response.body.data.content;
						

			}, response => {

			});
		}
	}
</script>

<style lang="scss">
	#yonghuxieyi{
		width: 100%;
		.download_header {
			width: 100%;
			height: 155px;
			.download_header_img {
				display: block;
				width: 100%;
				height: 155px;
			}
		}
		#y_main{
			margin:0 auto;
			width: 1200px;
			#agree_rdt{
				text-align: left;

			}
		}
	}

	
	
</style>


// WEBPACK FOOTER //
// src/components/yonghuxieyi.vue